import { ref } from 'vue';
import axios from '@/services/useAxios';

export default function () {
    const notification = ref(null);

    const getNotification = async (id) => {
        const res = await axios.get(`/notifications/${id}`);
        if (res.status === 200) {
            notification.value = res.data;
        } else {
            throw new Error(res.data.errors);
        }
    };

    const deleteNotification = async (id) => {
        const res = await axios.delete(`/notifications/${id}`);
        if (res.status === 200) {
            notification.value = res.data;
        } else {
            throw new Error(res.data.errors);
        }
    };

    return {
        notification,
        getNotification,
        deleteNotification,
    };
}
